import { Component, NgZone, afterNextRender } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from '../guards/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import {
  DtoUserCreate,
  DtoUserLogin,
  Invitation,
  UserItemEssentials,
} from '../api/models';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { IdentityService } from '../api/services/identity.service';
import { TaskParameters } from '../loading-page/loading-page.component';
import { Title } from '@angular/platform-browser';
import { InvitationService } from '../api/services';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-modal-login',
  templateUrl: './modal-login.component.html',
  styleUrl: './modal-login.component.scss',
})
export class ModalLoginComponent {
  showRegister = false;
  passwordRegx: RegExp =
    /^(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\d\s:])([^\s]){5,}$/;
  activation_code = false;
  activation_code_error = false;
  err_message = '';
  login_error = false;
  passwordForgotten = false;
  passwordForgotten_msg = false;
  checked_conditions = false;
  checked_data = false;
  gotoWithoutLogin?: string;
  googleUrl = environment.baseUrl + '/identity/session/google';

  invitation_reg?: Invitation;
  invitation_join?: Invitation;
  invitation_assignment?: Invitation;

  frmLogin = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
  });

  frmRegister = new FormGroup({
    activationMode: new FormControl('EMAIL', [Validators.required]),
    role_id: new FormControl(2, [Validators.required]),
    checked_conditions: new FormControl(undefined, [Validators.required]),
    email: new FormControl('', [Validators.required]),
    password: new FormControl('', {
      validators: [Validators.required, Validators.pattern(this.passwordRegx)],
    }),
  });

  frmForgottenPass = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });
  urlToNavigate?: string;
  back_to_url?: string;

  constructor(
    public ref: DynamicDialogRef,
    private router: Router,
    private ar: ActivatedRoute,
    private identityService: IdentityService,
    private auth: AuthService,
    private http: HttpClient,
    private title: Title,
    private invitationService: InvitationService,
    private zone: NgZone,
    public config: DynamicDialogConfig,
  ) {
    this.gotoWithoutLogin = config.data?.gotoWithoutLogin;
    afterNextRender(() => {
      if (sessionStorage.getItem('urlToNavigate')) {
        this.urlToNavigate = sessionStorage.getItem('urlToNavigate')!;
        this.checkInvitation();
      }
      if (sessionStorage.getItem('urlToNavigateNotifications')) {
        this.urlToNavigate = sessionStorage.getItem(
          'urlToNavigateNotifications',
        )!;
        this.checkAssignment();
      }
    });
  }

  ngOnInit() {
    this.title.setTitle('SocialTravels - Login');
    if (this.auth.isLogged()) {
      this.router.navigateByUrl('/');
    }
    this.ar.data.subscribe((p) => {
      if (p['register'] === true) {
        this.showRegister = true;
      }
    });

    this.ar.queryParams.subscribe((p) => {
      // back to url
      if (p['back_to_url']) {
        this.back_to_url = p['back_to_url'];
      }
      // error from loading
      if (p['e'] && p['e'] === 1) {
        this.login_error = true;
        this.err_message = 'Errore durante il login. Riprova.';
      }

      if (p['invite']) {
        this.invitationService
          .invitationControllerFindOne({ identifier: p['invite'] })
          .subscribe({
            next: (res) => {
              this.invitation_reg = res.data.invitation;
            },
          });
      }
    });
  }

  login() {
    // sessionStorage.clear();
    const body: DtoUserLogin = this.frmLogin.value as any;
    this.identityService.identityControllerLoginPassport({ body }).subscribe({
      next: (res) => {
        this.ref.close();
        // back to url
        if (this.back_to_url) {
          this.router.navigateByUrl(decodeURIComponent(this.back_to_url));
          return;
        }
        let redirectTo = '/';
        if (this.urlToNavigate!) {
          redirectTo = this.urlToNavigate!;
          sessionStorage.clear();
        }
        if (sessionStorage.getItem('book_item_redirect')) {
          redirectTo = sessionStorage.getItem('book_item_redirect')!;
          sessionStorage.clear();
        }
        if (sessionStorage.getItem('review_business_redirect')) {
          redirectTo = sessionStorage.getItem('review_business_redirect')!;
          sessionStorage.clear();
        }
        const state: TaskParameters = {
          action: 'post-login',
          params: { token: res.data.access_token },
          redirectTo,
        };
        this.router.navigate(['/loading'], { state });
      },
      error: (res) => {
        this.login_error = true;
        if (res.status === 401) {
          this.err_message =
            'La password o la mail inserite non sono corrette.';
        } else {
          this.err_message = 'Qualcosa è andato storto.';
        }
      },
    });
  }

  gotoRegister() {
    this.router.navigate(['/register'], {
      queryParams: this.back_to_url ? { back_to_url: this.back_to_url } : {},
    });
    this.ref.close();
  }

  proceedWithoutRegister() {
    this.router.navigateByUrl(this.gotoWithoutLogin!);
    this.ref.close();
  }

  register() {
    const body: DtoUserCreate = this.frmRegister.value as any;
    this.identityService
      .identityControllerRegister({
        body: {
          activationMode: body.activationMode,
          email: body.email,
          password: body.password,
          role_id: body.role_id,
          invitation_identifier: this.invitation_join?.identifier,
          back_to_url: this.back_to_url,
        },
      })
      .subscribe({
        next: (res) => {
          this.activation_code = true;
          if (this.invitation_reg) {
            this.invitationService
              .invitationControllerAccept({
                identifier: this.invitation_reg.identifier,
              })
              .subscribe({
                next: (res) => {},
              });
          }
        },
        error: (err) => {
          this.activation_code_error = true;
          if (err.status === 400) {
            this.err_message = 'Qualcosa è andato storto.';
          } else {
            this.err_message =
              'Si è verificato un errore tecnico, riprova più tardi.';
          }
        },
      });
  }

  getPassword() {
    const body = this.frmForgottenPass.value as any;
    this.identityService.identityControllerForgotPassword({ body }).subscribe({
      next: (res) => {
        this.passwordForgotten_msg = true;
      },
    });
  }

  close() {
    this.ref.close();
  }

  private checkInvitation() {
    const search = this.urlToNavigate!.split('?')[1];
    const invite = search.split('=')[1];
    this.invitationService
      .invitationControllerFindOne({ identifier: invite })
      .subscribe({
        next: (res) => {
          this.zone.run(() => {
            this.invitation_join = res.data.invitation;
            if (sessionStorage.getItem('urlToNavigateNotifications'))
              this.invitation_assignment = res.data.invitation;
          });
        },
      });
  }

  private checkAssignment() {
    const search = this.urlToNavigate!.split('?')[1];
    const invite = search.split('=')[1];
    this.invitationService
      .invitationControllerFindOne({ identifier: invite })
      .subscribe({
        next: (res) => {
          this.zone.run(() => {
            this.invitation_assignment = res.data.invitation;
            if (this.auth.user.value?.email != res.data.invitation.to_email) {
              this.router.navigate(['/redirect-to']);
            }
          });
        },
      });
  }

  goToHomepage() {
    this.router.navigateByUrl('/');
    sessionStorage.clear();
  }
}
